"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _withContentstackPreview = _interopRequireDefault(require("./withContentstackPreview"));

exports.default = _withContentstackPreview.default;